import { LoadingButton } from '@mui/lab';
import { Button, Stack, useTheme } from '@mui/material';

interface UserModalActionsProps {
  onCancel: () => void;
  isSubmitting: boolean;
  isFormValid: boolean;
}

export const UserModalActions = ({
  onCancel,
  isSubmitting,
  isFormValid,
}: UserModalActionsProps) => {
  const theme = useTheme();
  return (
    <Stack
      direction="row"
      spacing={1}
      sx={{ alignSelf: 'flex-end', marginTop: theme.spacing(2) }}
    >
      <Button type="button" onClick={onCancel} disabled={isSubmitting} color="inherit">
        Cancel
      </Button>
      <LoadingButton
        type="submit"
        loading={isSubmitting}
        disabled={!isFormValid || isSubmitting}
      >
        Submit
      </LoadingButton>
    </Stack>
  );
};

UserModalActions.displayName = 'UserModalActions';
